(() => {
  function initialize(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const select = root.querySelector('[data-popy-variant]');
    const update = () => {
      const option = select.selectedOptions[0];
      root.querySelector('[data-popy-price]').textContent = option.dataset.price;
      const sku = root.querySelector('[data-product-sku]');
      sku.dataset.skuValue = option.dataset.sku;
      sku.dataset.variantId = option.value;
      sku.textContent = option.dataset.sku;
      const available = option.dataset.available === 'true';
      const button = root.querySelector('[data-popy-add]');
      button.disabled = !available;
      button.textContent = available ? 'Add to cart' : 'Sold out';
      const count = Math.max(1, Math.min(4, Number(option.dataset.photoCount) || 1));
      root.querySelectorAll('[data-popy-photo]').forEach(field => {
        const enabled = Number(field.dataset.popyPhoto) <= count;
        field.hidden = !enabled;
        const input = field.querySelector('input');
        input.disabled = !enabled;
        input.required = enabled;
      });
    };
    select.addEventListener('change', update);
    root.querySelectorAll('input[type=file]').forEach(input => {
      const field = input.closest('[data-popy-photo]');
      const upload = field.querySelector('[data-popy-upload]');
      const preview = field.querySelector('[data-popy-upload-preview]');
      let previewUrl;
      input.addEventListener('change', () => {
        const file = input.files[0];
        const error = file && (file.size > 10 * 1024 * 1024 || !['image/jpeg', 'image/png'].includes(file.type)) ? 'Please choose a JPG or PNG image up to 10 MB.' : '';
        input.setCustomValidity(error);
        if (previewUrl) URL.revokeObjectURL(previewUrl);
        previewUrl = null;
        preview.hidden = true;
        preview.removeAttribute('src');
        const selected = Boolean(file && !error);
        upload.classList.toggle('is-selected', selected);
        upload.classList.toggle('has-error', Boolean(error));
        field.querySelector('[data-popy-upload-title]').textContent = selected ? 'Photo selected' : 'Add your pet’s photo';
        field.querySelector('[data-popy-upload-name]').textContent = file ? file.name : 'Choose a favorite JPG or PNG';
        field.querySelector('[data-popy-upload-button]').textContent = file ? 'Change photo' : 'Choose photo';
        field.querySelector('[data-popy-upload-status]').textContent = error || (selected ? 'Photo selected. Add to cart to save it with your piece.' : '');
        if (selected) {
          previewUrl = URL.createObjectURL(file);
          preview.src = previewUrl;
          preview.hidden = false;
        }
        input.reportValidity();
      });
    });
    update();
  }
  document.querySelectorAll('[data-popy-custom]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-popy-custom]').forEach(initialize));
})();
